import React from 'react';
import { Drawer } from 'vaul';
import { CloseXComponent as CloseXIcon } from 'ui/Icons';

interface ISearchDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const SearchDrawer = (props: ISearchDrawerProps) => {
  return (
    <Drawer.Root direction="left" open={props.isOpen} onOpenChange={(open) => { if (!open) props.onClose(); }} dismissible={true}>
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 bg-black/40 z-[99998]" />
        <Drawer.Content className="h-[100dvh] bg-white p-[20px] w-[80%] max-w-[340px] fixed top-0 left-0 outline-none z-[99999]">
          <div className="relative flex flex-col h-full">
            <div className="flex items-center justify-between mb-[20px]">
              <span className="font-pt-sans font-bold text-[17px] text-black">Search & Filters</span>
              <button
                onClick={props.onClose}
                className="bg-transparent outline-none cursor-pointer p-0 border-none"
              >
                <CloseXIcon />
              </button>
            </div>

            <div
              className="flex-1 overflow-y-auto overflow-x-hidden select-text touch-auto"
              data-vaul-no-drag
            >
              {props.children}
            </div>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
};
